import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

const adminHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}`,
});

export const fetchHotelAvailability = async (startDate, endDate) => {
  const { data } = await axios.get(`${API_BASE_URL}/api/admin/hotel-availability`, {
    params: { startDate, endDate, _: Date.now() },
    headers: adminHeaders(),
  });
  return Array.isArray(data) ? data : [];
};

export const updateHotelAvailability = async (payload) => {
  const { data } = await axios.post(`${API_BASE_URL}/api/admin/hotel-availability`, payload, {
    headers: adminHeaders(),
  });
  return Array.isArray(data) ? data : [];
};

export const markHotelSoldOut = async (payload) => {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/admin/hotel-availability/hotel-sold-out`,
    payload,
    { headers: adminHeaders() },
  );
  return Array.isArray(data) ? data : [];
};

export const undoHotelSoldOut = async (payload) => {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/admin/hotel-availability/hotel-sold-out/undo`,
    payload,
    { headers: adminHeaders() },
  );
  return Array.isArray(data) ? data : [];
};

// Rooms held for Iotrips ahead of demand. Admin only; nothing releases a hold except an admin.
export const fetchRoomHolds = async (includeReleased = false) => {
  const { data } = await axios.get(`${API_BASE_URL}/api/admin/hotel-holds`, {
    params: { includeReleased, _: Date.now() },
    headers: adminHeaders(),
  });
  return Array.isArray(data) ? data : [];
};

export const createRoomHold = async (payload) => {
  const { data } = await axios.post(`${API_BASE_URL}/api/admin/hotel-holds`, payload, {
    headers: adminHeaders(),
  });
  return Array.isArray(data) ? data : [];
};

export const releaseRoomHold = async (id) => {
  const { data } = await axios.post(`${API_BASE_URL}/api/admin/hotel-holds/${id}/release`, {}, {
    headers: adminHeaders(),
  });
  return data;
};

export const confirmRoomHold = async (id) => {
  const { data } = await axios.post(`${API_BASE_URL}/api/admin/hotel-holds/${id}/confirm`, {}, {
    headers: adminHeaders(),
  });
  return data;
};

export const fetchPendingHotelConfirmations = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/api/admin/hotel-confirmations/pending`, {
    params: { _: Date.now() },
    headers: adminHeaders(),
  });
  return Array.isArray(data) ? data : [];
};

/** Stays the hotel accepted whose room numbers have moved since - they need telling again. */
export const fetchHotelRoomNumberChanges = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/api/admin/hotel-confirmations/room-changes`, {
    params: { _: Date.now() },
    headers: adminHeaders(),
  });
  return Array.isArray(data) ? data : [];
};

export const markHotelRoomsNotified = async (confirmationId) => {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/admin/hotel-confirmations/${confirmationId}/rooms-notified`,
    {},
    { headers: adminHeaders() },
  );
  return data;
};

/** One-off: names rooms for trips booked before room numbers existed. Safe to run again. */
export const backfillHotelRoomAssignments = async () => {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/admin/hotel-confirmations/room-assignments/backfill`,
    {},
    { headers: adminHeaders() },
  );
  return data || {};
};
